import {Injectable} from '@angular/core'
import {HttpClient} from '@angular/common/http'
import {catchError, map, Observable, of} from 'rxjs'
import {DayPilot} from '@daypilot/daypilot-lite-angular'
import {VehicleBlockTimeRequest, VehicleModel, VVehicleBlockTimeModel} from "../../../domain/src/lib/vehicle.model"
import {environment} from "../../../../apps/frontend/src/environments/environment"
import CalendarColumnData = DayPilot.CalendarColumnData


@Injectable({
  providedIn: 'root',
})
export class VehicleService {

  constructor(
      private readonly http: HttpClient,
  ) {
  }


  getVehicles(isActive: boolean): Observable<VehicleModel[]> {
    const active = isActive ? 'true' : 'undefined'
    const url = `${environment.apiUrl}/vehicles?active=${active}`
    return this.http.get<VehicleModel[]>(url).pipe(
        map(values => {
          return values
        }),
    )
  }


  getCalResources(): Observable<CalendarColumnData[]> {
    const url = `${environment.apiUrl}/vehicles/resources?active`
    return this.http.get<CalendarColumnData[]>(url).pipe(
        map(values => {
          return values
        }),
    )
  }


  getVehiclesByVehicleId(vehicleId: number): Observable<VehicleModel[]> {
    const url = `${environment.apiUrl}/vehicles/${vehicleId}`
    return this.http.get<VehicleModel[]>(url).pipe(
        map(values => {
          return values
        }),
    )
  }


  getVehiclesByUserId(userId: number): Observable<VehicleModel> {
    const url = `${environment.apiUrl}/vehicles/users/${userId}`
    return this.http.get<VehicleModel[]>(url).pipe(
        map(values => {
          return values[0]
        }),
    )
  }


  getBlockTimesByVehicleId(vehicleId: number): Observable<VVehicleBlockTimeModel[]> {
    const url = `${environment.apiUrl}/vehicles/${vehicleId}/blocktimes`
    return this.http.get<VVehicleBlockTimeModel[]>(url).pipe(
        map(values => {
          return values
        }),
    )
  }


  addVehicle(vehicle: VehicleModel): Observable<any> {
    const url = `${environment.apiUrl}/vehicles`
    // return this.http.post<number>(url, vehicle).pipe(
    const res = this.http.post(url, vehicle).pipe(
        map(value => {
          return value
        }),
    )
    return res
  }


  updateVehicle(vehicle: VehicleModel): Observable<number> {
    const url = `${environment.apiUrl}/vehicles/${vehicle.id}`
    const res = this.http.put<number>(url, vehicle).pipe(
        map(value => {
          return value
        }),
    )
    return res
  }


  deleteVehiclesByIds(vehicleIds: number[]): Observable<any> {
    const url = `${environment.apiUrl}/vehicles/${vehicleIds}`
    return this.http.delete(url).pipe(
        catchError(this.handleError('deleteVehicle')),
    )
  }


  addBlockTime(blockTime: VehicleBlockTimeRequest): Observable<any> {
    const url = `${environment.apiUrl}/vehicles/${blockTime.vehicleId}/blocktimes`
    // return this.http.post<number>(url, vehicle).pipe(
    const res = this.http.post(url, blockTime).pipe(
        map(value => {
          return value
        }),
    )
    return res
  }


  deleteBlockTimesByBlockTimeIds(blockTimeIds: number[]): Observable<any> {
    const url = `${environment.apiUrl}/vehicles/blocktimes/${blockTimeIds}`
    const res = this.http.delete(url).pipe(
        map(value => {
          return value
        }),
    )
    return res
  }


  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<boolean> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error) // log to console instead
      // TODO: better job of transforming error for vehicle consumption
      // this.log(`${operation} failed: ${error.message}`)
      // Let the app keep running by returning an empty result.
      return of(false)
    }
  }
}
